import "./CaptionPricingSection.scss";

const PLANS = [
  {
    id: "free",
    name: "Free",
    badge: null,
    price: "Free",
    period: "",
    description: "Try Caption Publishing with core limits on every Google account.",
    features: [
      "3 hours total processed time",
      "20 minutes per video",
      "100 MB max file size",
      "Phonetic + native script output",
      "SRT and VTT downloads",
    ],
    ctaVariant: "outline",
  },
  {
    id: "silver",
    name: "Silver",
    badge: null,
    price: "$12",
    period: "/ month",
    description: "For creators publishing regularly with higher volume needs.",
    features: [
      "12 hours total processed time",
      "45 minutes per video",
      "250 MB max file size",
      "Priority processing queue",
      "Email support",
    ],
    ctaVariant: "soft",
  },
  {
    id: "gold",
    name: "Gold",
    badge: "Most popular",
    price: "$29",
    period: "/ month",
    description: "For professionals and small teams with medium production needs.",
    features: [
      "40 hours total processed time",
      "90 minutes per video",
      "500 MB max file size",
      "Fast-track transcription",
      "3 team seats",
    ],
    ctaVariant: "primary",
    featured: true,
  },
  {
    id: "platinum",
    name: "Platinum",
    badge: null,
    price: "$79",
    period: "/ month",
    description: "For agencies and teams with large caption workloads.",
    features: [
      "Unlimited processed time",
      "Unlimited video duration",
      "1 GB max file size",
      "Dedicated account manager",
      "5 team seats",
    ],
    ctaVariant: "soft",
  },
];

const CaptionPricingSection = ({ isLoggedIn, onFreePlanClick, onGetStarted }) => (
  <section id="caption-pricing" className="cp-pricing" aria-labelledby="cp-pricing-heading">
    <div className="cp-pricing__head">
      <h2 id="cp-pricing-heading" className="cp-pricing__title">
        Find the best plan for you
      </h2>
      <p className="cp-pricing__subtitle">
        Upgrade when you outgrow the free tier. All plans include phonetic and native-script
        captions.
      </p>
    </div>

    <div className="cp-pricing__grid">
      {PLANS.map((plan) => {
        const isFree = plan.id === "free";
        const ctaLabel = isFree ? (isLoggedIn ? "Enjoy" : "Sign up") : "Get started";

        return (
          <article
            key={plan.id}
            className={`cp-pricing__card cp-pricing__card--${plan.id}${
              plan.featured ? " cp-pricing__card--featured" : ""
            }`}
          >
            {plan.badge && <span className="cp-pricing__popular">{plan.badge}</span>}
            <h3 className="cp-pricing__plan-name">{plan.name}</h3>
            <p className="cp-pricing__plan-desc">{plan.description}</p>
            <div className="cp-pricing__price-row">
              <span className="cp-pricing__price">{plan.price}</span>
              {plan.period && <span className="cp-pricing__period">{plan.period}</span>}
            </div>
            <button
              type="button"
              className={`cp-pricing__cta cp-pricing__cta--${plan.ctaVariant}`}
              onClick={() => (isFree ? onFreePlanClick() : onGetStarted(plan))}
            >
              {ctaLabel}
            </button>
            <ul className="cp-pricing__features">
              {plan.features.map((feature) => (
                <li key={feature}>{feature}</li>
              ))}
            </ul>
          </article>
        );
      })}
    </div>
  </section>
);

export default CaptionPricingSection;
